import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/Choicest_Fruit.png";
import syepMain from "../../Assets/syepMain.png";
import cf2025 from "../../Assets/syep_2025.jpeg";
import cfCommunity1 from "../../Assets/cf-community-1.png";
import cfCommunity2 from "../../Assets/cf-community-2.png";
import cfCommunity3 from "../../Assets/cf-community-3.png";
import cfCommunity4 from "../../Assets/cf-community-4.png";
import cfCommunity6 from "../../Assets/cf-community-6.png";
import cfCommunity7 from "../../Assets/cf-community-7.png";
import cfCommunity8 from "../../Assets/cf-community-8.png";
import cfCommunity9 from "../../Assets/cf-community-9.png";
import cfCommunity10 from "../../Assets/cf-community-10.png";
import Card from "react-bootstrap/Card";
import useInViewOnce from "../../hooks/useInViewOnce";
import { Trans, useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";

function About() {
  const { t } = useTranslation();
  const { ref: valuesRef, inView: valuesInView, hasEntered: valuesSeen } = useInViewOnce({ once: false });

  const [activeSlide, setActiveSlide] = React.useState(0);

  const sliderImages = [
    { src: cfCommunity1, altKey: "aboutWho.sliderAlts.2" },
    { src: syepMain, altKey: "aboutWho.sliderAlts.0" },
    { src: cfCommunity6, altKey: "aboutWho.sliderAlts.7" },  
    { src: cfCommunity2, altKey: "aboutWho.sliderAlts.3" },
    { src: cfCommunity3, altKey: "aboutWho.sliderAlts.4" },
    { src: cf2025, altKey: "aboutWho.sliderAlts.1" },
    { src: cfCommunity4, altKey: "aboutWho.sliderAlts.5" },
    { src: cfCommunity7, altKey: "aboutWho.sliderAlts.8" },
    { src: cfCommunity8, altKey: "aboutWho.sliderAlts.9" },
    { src: cfCommunity9, altKey: "aboutWho.sliderAlts.10" },
    { src: cfCommunity10, altKey: "aboutWho.sliderAlts.11" },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2400,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  const translatedCoreValues = t("aboutWho.coreValues.items", { returnObjects: true });
  const coreValues = Array.isArray(translatedCoreValues) ? translatedCoreValues : [];

  const visionP3 = t("aboutWho.vision.p3");
  const hasVisionP3 = Boolean(visionP3) && visionP3 !== "aboutWho.vision.p3";

  return (
    <Container fluid className="about-section about-page">
      <Particle />
      <Container className="about-container">
        <header className="about-hero">
          <h1 className="about-hero-title">
            <Trans i18nKey="aboutWho.hero.title" components={{ purple: <span className="purple" /> }} />
          </h1>
          <p className="about-hero-lead">
            {t("aboutWho.hero.lead")}
          </p>
        </header>

        <Row className="about-top">
          <Col xs={12} md={6} className="about-top-col">
            <h2 className="about-section-heading about-section-heading--ghost" aria-hidden="true">
              <Trans i18nKey="aboutWho.whoWeAreHeading" components={{ purple: <span className="purple" /> }} />
            </h2>
            <Aboutcard />
          </Col>

          <Col xs={12} md={6} className="about-top-col">
            <h2 className="about-section-heading about-section-heading--ghost" aria-hidden="true">
              <Trans i18nKey="aboutWho.whoWeAreHeading" components={{ purple: <span className="purple" /> }} />
            </h2>

            <div
              className="policy-card mission-image-card mission-slider-card mission-top-media-card about-top-media-card"
              aria-label={t("aboutWho.a11y.imageCardLabel")}
            >
              <Slider {...sliderSettings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="mission-slide">
                    <SlickLazyImage
                      src={image.src}
                      alt={t(image.altKey)}
                      className="mission-slide-img"
                      index={index}
                      activeIndex={activeSlide}
                      total={sliderImages.length}
                      buffer={2}
                      eager
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        <Row className="about-who-bottom g-0" xs={1} md={2} aria-label={t("aboutWho.a11y.visionValuesLabel")}>
          <Col className="about-top-col order-2 order-md-1">
            <Card className="policy-card about-image-card" aria-label={t("aboutWho.a11y.imageCardLabel")}>
              <img src={laptopImg} alt={t("aboutWho.a11y.imageAlt")} className="about-image" />
            </Card>
          </Col>

          <Col className="about-top-col order-1 order-md-2">
            <Card className="policy-card about-card about-who-card" aria-label={t("aboutWho.a11y.visionCardLabel")}>
              <Card.Body>
                <blockquote className="blockquote mb-0">
                  <p className="about-text">
                    <Trans i18nKey="aboutWho.vision.p1" components={{ purple: <span className="purple" /> }} />
                  </p>

                  <p className="about-text">{t("aboutWho.vision.p2")}</p>

                  {hasVisionP3 ? <p className="about-text">{visionP3}</p> : null}
                </blockquote>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="about-who-name-row" style={{ justifyContent: "center" }} aria-label={t("aboutWho.a11y.nameCardLabel")}>
          <Col md={10} className="about-top-col">
            <Card className="policy-card about-card about-who-card" aria-label={t("aboutWho.a11y.nameCardLabel")}>
              <Card.Body>
                <blockquote className="blockquote mb-0">
                  <p className="about-text">
                    <Trans
                      i18nKey="aboutWho.nameMeaning.p1"
                      components={{
                        r: <span className="small-r-symbol">®</span>,
                        purple: <span className="purple" />,
                      }}
                    />
                  </p>

                  <p className="about-text">
                    <Trans i18nKey="aboutWho.nameMeaning.p2" components={{ purple: <span className="purple" /> }} />
                  </p>

                  <Card className="policy-card about-quote-card" aria-label={t("aboutWho.a11y.quoteCardLabel")}>
                    <Card.Body className="about-quote-body">
                      <div className="about-quote-text">{t("aboutWho.nameMeaning.quote")}</div>
                    </Card.Body>
                  </Card>
                </blockquote>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <section className="about-section-block" aria-label={t("aboutWho.a11y.coreValuesSectionLabel")}>
          <h2 className="about-section-heading">
            <Trans i18nKey="aboutWho.coreValues.heading" components={{ purple: <span className="purple" /> }} />
          </h2>

          <div
            ref={valuesRef}
            className={`about-values-grid${valuesSeen ? " about-seen" : ""}${
              valuesInView ? " about-inview" : ""
            }`}
          >
            {coreValues.map((value, index) => (
              <Card
                key={`${value.title}-${index}`}
                className="policy-card about-value-card about-anim-card about-anim-bounce"
                style={{ animationDelay: `${index * 90}ms` }}
              >
                <Card.Body>
                  <blockquote className="blockquote mb-0">
                    <div className="about-value-title">{value.title}</div>
                    <p className="about-text about-value-text">{value.body}</p>
                  </blockquote>
                </Card.Body>
              </Card>
            ))}
          </div>
        </section>

        <section className="about-section-block" aria-label={t("aboutWho.a11y.beliefsSectionLabel")}>
          <h2 className="about-section-heading">
            <Trans i18nKey="aboutWho.beliefs.heading" components={{ purple: <span className="purple" /> }} />
          </h2>
          <Techstack />
        </section>
      </Container>
    </Container>
  );
}

export default About;
